export enum StampDutyValuationEnum {
    hdb = "V",
    hdb_resale_price = "M",
    own_opinion = "D"
}